<div class="wrapper">
  @if (project.workSpaces.length === 1 || !isClosed) {
    <gl-loading-space-description (isClosedEvent)="isClosedEvent($event)"> </gl-loading-space-description>
  }
  @if (!isClosed) {
    <div>
      @for (summary of cargoSpacesSummary; track summary; let i = $index) {
        <gl-loading-space-summary
          [summary]="summary"
          [cargoSpace]="cargoSpaces[i]"
          [index]="i"
          [isSet]="cargoSpaces.length === 2"
        ></gl-loading-space-summary>
      }
    </div>
  }
</div>
